import React, {useContext} from 'react'
import './StoreLink.css'
import {AppContext} from '../App'

export default function StoreLink() {
  const { app } = useContext(AppContext)
  const href = `https://app.adjust.com/e6kekr_g133en?campaign=StorySharing&adgroup=${app?.hash}`
  const trackerSrcIos = `https://view.adjust.com/impression/e6kekr?campaign=StorySharing&adgroup=${app?.hash}`
  const trackerSrcAndroid = `https://view.adjust.com/impression/g133en?campaign=StorySharing&adgroup=${app?.hash}`
  return (
    <div className="bottom-fix">
      <a className="store-link" href={href}>
        <div className="tracker">
          <img src={trackerSrcIos} alt="" />
          <img src={trackerSrcAndroid} alt="" />
        </div>
        <img src="https://nohana.jp/img/renewal/nohana_icon.png" alt="" />
        <p>「ノハナ」で思い出をアルバムに残そう</p>
        <span>無料</span>
      </a>
    </div>
  )
}
